import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService, Global } from 'asap-crud';

@Injectable({
  providedIn: 'root'
})
export class AsapUploadService extends BaseService {

  constructor(
    public global: Global,
    public http: HttpClient
  ) { 
    super(http);
  }

  public upload(formData) {
    let client_id = this.global.loggedUser().client_id;
    let url = 'https://apiv3.plataformaasap.com.br/api/cloudinary/upload?client_id='+client_id;
    return this.http.post(url, formData, {reportProgress:true, observe:'events'});
  }
}
